document.addEventListener('DOMContentLoaded', function() {
  // Current language (default: German)
  let currentLang = 'de';
  let simpleDict = {};
  let complexDict = {};
  let ui = {};

  // Initialize dictionaries for current language
  function setLanguage(lang) {
    currentLang = lang;
    if (window.translatorDicts && window.translatorDicts[lang]) {
      simpleDict = window.translatorDicts[lang].simple;
      complexDict = window.translatorDicts[lang].complex;
      ui = window.translatorDicts[lang].ui;
    }
    // Update global references for backwards compatibility
    window.simpleDict = simpleDict;
    window.complexDict = complexDict;

    // Update preview cards
    updatePreviewCards();
  }

  // Update the term preview cards and technique cards based on current language
  function updatePreviewCards() {
    // Update simple term cards
    document.querySelectorAll('.term-card[data-term]').forEach(card => {
      const term = card.getAttribute('data-term');
      const translatedSpan = card.querySelector('.term-translated');
      if (translatedSpan) {
        // Check simple dict first, then complex dict
        if (simpleDict[term]) {
          translatedSpan.textContent = simpleDict[term];
        } else if (complexDict[term]) {
          translatedSpan.textContent = complexDict[term].translation;
        }
      }
    });

    // Update complex technique cards
    document.querySelectorAll('.complex-technique-item[data-term]').forEach(card => {
      const term = card.getAttribute('data-term');
      const translatedSpan = card.querySelector('.technique-translated');
      const imgElement = card.querySelector('.technique-thumbnail img');

      if (complexDict[term]) {
        if (translatedSpan) {
          translatedSpan.textContent = complexDict[term].translation;
        }
        if (imgElement && complexDict[term].videoId) {
          imgElement.src = `https://i.ytimg.com/vi/${complexDict[term].videoId}/mqdefault.jpg`;
        }
      } else if (simpleDict[term]) {
        if (translatedSpan) {
          translatedSpan.textContent = simpleDict[term];
        }
      }
    });
  }

  // Set initial language
  setLanguage('de');

  // DOM elements
  const inputText = document.getElementById('inputText');
  const outputText = document.getElementById('outputText');
  const translateButton = document.getElementById('translateButton');
  const clearButton = document.getElementById('clearButton');
  const copyButton = document.getElementById('copyButton');
  const sampleButton = document.getElementById('sampleButton');
  const charCount = document.getElementById('charCount');
  const languageSelect = document.getElementById('languageSelect');

  // Tooltip setup
  const tooltip = document.createElement('div');
  tooltip.id = 'knitting-tooltip';
  tooltip.style.display = 'none';
  let hideTooltipTimeout = null;
  document.body.appendChild(tooltip);

  tooltip.addEventListener('mouseenter', () => {
    clearTimeout(hideTooltipTimeout);
  });
  tooltip.addEventListener('mouseleave', () => {
    hideTooltipTimeout = setTimeout(hideTooltip, 100);
  });

  let mouseOverTooltip = false;
  let activeTermElem = null;

  // Table scroll indicator
  const tableContainers = document.querySelectorAll('.table-responsive');
  tableContainers.forEach(container => {
    container.addEventListener('scroll', function() {
      const isScrolledToEnd = this.scrollLeft + this.clientWidth >= this.scrollWidth - 5;
      if (isScrolledToEnd) {
        this.classList.add('scrolled-all-the-way');
      } else {
        this.classList.remove('scrolled-all-the-way');
      }
    });
    container.dispatchEvent(new Event('scroll'));
  });

  function hideTooltip() {
    if (!mouseOverTooltip) {
      tooltip.style.display = 'none';
      activeTermElem = null;
    }
  }

  tooltip.addEventListener('mouseenter', function() {
    mouseOverTooltip = true;
  });
  tooltip.addEventListener('mouseleave', function() {
    mouseOverTooltip = false;
    setTimeout(hideTooltip, 100);
  });

  function handleGlobalMouseMove(e) {
    const overTooltip = !!e.target.closest('#knitting-tooltip');
    const target = e.target.closest('.highlighted-complex');

    if (overTooltip) return;

    if (tooltip.style.display === 'block' && activeTermElem) {
      if (target && target !== activeTermElem) return;
    }

    if (!target) return;

    activeTermElem = target;
    const originalTerm = target.querySelector('.original-term');
    if (!originalTerm) return;

    const termText = originalTerm.textContent.replace(/[()]/g, '');
    const termInfo = complexDict[termText];
    if (!termInfo) return;

    const videoHtml = termInfo.videoId
      ? `<a href="https://youtube.com/watch?v=${termInfo.videoId}" class="video-link" target="_blank">${ui.videoLink || 'Video-Tutorial ansehen'}</a>`
      : '';
    tooltip.innerHTML = `${termInfo.description}<br>${videoHtml}`;

    const rect = target.getBoundingClientRect();
    tooltip.style.display = 'block';
    tooltip.style.opacity = '0';
    const ttRect = tooltip.getBoundingClientRect();
    const scrollX = window.pageXOffset;
    const scrollY = window.pageYOffset;

    let top = scrollY + rect.top - ttRect.height - 10;
    let left = scrollX + rect.left + (rect.width / 2) - (ttRect.width / 2);

    const margin = 10;
    if (left < margin) left = margin;
    if (left + ttRect.width > scrollX + window.innerWidth - margin) {
      left = scrollX + window.innerWidth - ttRect.width - margin;
    }
    if (top < scrollY + margin) {
      top = scrollY + rect.bottom + 10;
    }

    tooltip.style.top = `${top}px`;
    tooltip.style.left = `${left}px`;
    tooltip.style.opacity = '1';
  }

  function handleGlobalMouseOut(e) {
    if (e.target.closest('.highlighted-complex')) {
      const related = e.relatedTarget;
      if (related && (related.closest('#knitting-tooltip') || related.id === 'knitting-tooltip')) {
        return;
      }
      setTimeout(function() {
        if (!mouseOverTooltip) {
          hideTooltip();
        }
      }, 100);
    }
  }

  function init() {
    if (inputText) {
      inputText.addEventListener('input', updateCharCount);
    }
    if (translateButton) {
      translateButton.addEventListener('click', translateText);
    }
    if (clearButton) {
      clearButton.addEventListener('click', clearTexts);
    }
    if (copyButton) {
      copyButton.addEventListener('click', copyTranslation);
    }
    if (sampleButton) {
      sampleButton.addEventListener('click', loadSamplePattern);
    }
    if (languageSelect) {
      languageSelect.addEventListener('change', function() {
        setLanguage(this.value);
        // Re-translate if there's content
        if (inputText && inputText.value.trim()) {
          translateText();
        }
      });
    }

    updateCharCount();
    updatePreviewCards();
    document.addEventListener('mousemove', handleGlobalMouseMove);
    document.addEventListener('mouseout', handleGlobalMouseOut);
  }

  function updateCharCount() {
    if (!inputText || !charCount) return;
    const count = inputText.value.length;
    charCount.textContent = `${count} ${ui.charCount || 'Zeichen'}`;
  }

  function loadSamplePattern() {
    inputText.value = `Cast on 72 stitches using long tail cast on.

Row 1 (RS): *K2, p2; repeat from * to end.
Row 2 (WS): *P2, k2; repeat from * to end.
Repeat rows 1-2 until piece measures 8 inches.

Decrease row: K2tog across (36 stitches remain).
Work 6 rows in stockinette stitch.

Shape top:
Row 1: *K4, ssk; repeat from * to end.
Row 2 and all WS rows: Purl.
Row 3: *K3, k2tog; repeat from * to end.
Row 5: *K2, ssk; repeat from * to end.

Break yarn, thread through remaining stitches.
Bind off all stitches. Weave in ends and block.`;
    updateCharCount();
  }

  function translateText() {
    const text = inputText.value;
    if (!text.trim()) return;

    let translatedText = text;

    // Sort terms by length (longer first) to avoid partial replacements
    const sortedSimpleTerms = Object.keys(simpleDict).sort((a, b) => b.length - a.length);
    const sortedComplexTerms = Object.keys(complexDict).sort((a, b) => b.length - a.length);

    // Replace complex terms first (they have more context)
    sortedComplexTerms.forEach(term => {
      const regex = new RegExp(`\\b${escapeRegExp(term)}\\b`, 'gi');
      translatedText = translatedText.replace(regex, `${complexDict[term].translation} (${term})`);
    });

    // Replace simple terms
    sortedSimpleTerms.forEach(term => {
      const regex = new RegExp(`\\b${escapeRegExp(term)}\\b`, 'gi');
      translatedText = translatedText.replace(regex, (match) => `${match} (${simpleDict[term]})`);
    });

    // Handle stitch counts like k2, p3, k10
    const stitchK = ui.stitchK || 're';
    const stitchP = ui.stitchP || 'li';
    translatedText = translatedText.replace(/\b([kp])(\d+)\b/gi, (match, stitch, number) => {
      const stitchType = stitch.toLowerCase() === 'k' ? stitchK : stitchP;
      return `${number} ${stitchType}`;
    });

    // Replace row/round patterns
    const rowSingular = ui.row || 'Reihe';
    const rowPlural = ui.rows || 'Reihen';
    const roundSingular = ui.round || 'Runde';
    const roundPlural = ui.rounds || 'Runden';
    const timesWord = ui.times || 'mal';

    translatedText = translatedText.replace(/\brow\s+(\d+):/gi, `${rowSingular} $1:`);
    translatedText = translatedText.replace(/\brows\s+(\d+)-(\d+)/gi, `${rowPlural} $1-$2`);
    translatedText = translatedText.replace(/\bround\s+(\d+):/gi, `${roundSingular} $1:`);
    translatedText = translatedText.replace(/\brounds\s+(\d+)-(\d+)/gi, `${roundPlural} $1-$2`);

    // Handle repeat patterns
    translatedText = translatedText.replace(/\(([^)]+)\)(\s*\d+)(\s*times)/gi, `($1)$2 ${timesWord}`);

    // Convert inches to cm
    translatedText = translatedText
      .replace(/(\d+(?:\.\d+)?)\s*inches?\b/gi, (_, num) => {
        const cm = Math.round(parseFloat(num) * 2.54 * 10) / 10;
        return `${cm} cm`;
      })
      .replace(/(\d+)\/(\d+)\s*inch(?:es)?/gi, (_, num, den) => {
        const cm = Math.round((parseInt(num) / parseInt(den)) * 2.54 * 10) / 10;
        return `${cm} cm`;
      });

    // Add beta notice
    const betaNotice = ui.betaNotice || '[Bonifaktur BETA-Übersetzung - Es können Fehler passieren. Wenn Du welche entdeckst, lass es uns bitte wissen!]';
    translatedText += `\n\n---\n${betaNotice}`;

    outputText.value = translatedText;

    // Generate highlighted HTML output
    let htmlOutput = escapeHtml(translatedText);
    let placeholderMap = new Map();
    let placeholderCounter = 0;

    // Highlight complex terms
    sortedComplexTerms.forEach(englishTerm => {
      const translation = complexDict[englishTerm].translation;
      const pattern = `${escapeRegExp(translation)}\\s*\\(${escapeRegExp(englishTerm)}\\)`;
      const regex = new RegExp(pattern, 'g');
      htmlOutput = htmlOutput.replace(regex, (match) => {
        const placeholder = `__COMPLEX_TERM_${placeholderCounter++}__`;
        placeholderMap.set(placeholder, `<span class="highlighted-complex">${translation} <span class="original-term">(${englishTerm})</span></span>`);
        return placeholder;
      });
    });

    // Highlight simple terms
    const allTermPairs = [];
    sortedSimpleTerms.forEach(englishTerm => {
      if (simpleDict[englishTerm]) {
        allTermPairs.push({ english: englishTerm, translated: simpleDict[englishTerm] });
      }
    });

    allTermPairs.forEach(pair => {
      const pattern = `(\\b${escapeRegExp(pair.english)}\\b)\\s*\\(\\s*(${escapeRegExp(pair.translated)})\\s*\\)`;
      const regex = new RegExp(pattern, 'gi');
      htmlOutput = htmlOutput.replace(regex, (match, eng, trans) => {
        const placeholder = `__SIMPLE_TERM_${placeholderCounter++}__`;
        placeholderMap.set(placeholder, `${eng} (<span class="highlighted-term" data-original="${eng}">${trans}</span>)`);
        return placeholder;
      });
    });

    // Highlight stitch counts
    const stitchPattern = `(\\b[kp]\\d+\\b)\\s*\\(\\s*(${escapeRegExp(stitchK)}|${escapeRegExp(stitchP)})\\s*\\)`;
    htmlOutput = htmlOutput.replace(new RegExp(stitchPattern, 'gi'), (match, eng, trans) => {
      const placeholder = `__STITCH_TERM_${placeholderCounter++}__`;
      placeholderMap.set(placeholder, `${eng} (<span class="highlighted-term" data-original="${eng}">${trans}</span>)`);
      return placeholder;
    });

    // Replace placeholders with actual HTML
    placeholderMap.forEach((value, key) => {
      htmlOutput = htmlOutput.replace(key, value);
    });

    htmlOutput = htmlOutput.replace(/\n/g, '<br>');

    const highlightedOutput = document.getElementById('highlightedOutput');
    highlightedOutput.innerHTML = htmlOutput;
    highlightedOutput.style.display = 'block';
    outputText.style.display = 'none';

    // Show translation stats
    showTranslationStats(text, translatedText);

    bindComplexTooltips();
  }

  function showTranslationStats(original, translated) {
    const statsContainer = document.getElementById('translationStats');
    if (!statsContainer) return;

    // Count translated terms
    let simpleCount = 0;
    let complexCount = 0;

    Object.keys(simpleDict).forEach(term => {
      const regex = new RegExp(`\\b${escapeRegExp(term)}\\b`, 'gi');
      const matches = original.match(regex);
      if (matches) simpleCount += matches.length;
    });

    Object.keys(complexDict).forEach(term => {
      const regex = new RegExp(`\\b${escapeRegExp(term)}\\b`, 'gi');
      const matches = original.match(regex);
      if (matches) complexCount += matches.length;
    });

    const totalCount = simpleCount + complexCount;
    const statsText = ui.statsText || 'Begriffe übersetzt';
    const statsSimple = ui.statsSimple || 'einfache';
    const statsComplex = ui.statsComplex || 'komplexe Techniken';

    statsContainer.innerHTML = `<strong>${totalCount} ${statsText}</strong> (${simpleCount} ${statsSimple}, ${complexCount} ${statsComplex})`;
    statsContainer.style.display = 'block';
  }

  function bindComplexTooltips() {
    document.querySelectorAll('#highlightedOutput .highlighted-complex').forEach(term => {
      term.addEventListener('mouseenter', () => {
        clearTimeout(hideTooltipTimeout);
        activeTermElem = term;
        showTooltipFor(term);
      });
    });
  }

  function showTooltipFor(target) {
    const originalTerm = target.querySelector('.original-term');
    if (!originalTerm) return;

    const termText = originalTerm.textContent.replace(/[()]/g, '');
    const termInfo = complexDict[termText];
    if (!termInfo) return;

    const videoHtml = termInfo.videoId
      ? `<a href="https://youtube.com/watch?v=${termInfo.videoId}" class="video-link" target="_blank">${ui.videoLink || 'Video-Tutorial ansehen'}</a>`
      : '';
    tooltip.innerHTML = `${termInfo.description}<br>${videoHtml}`;
    positionTooltip(target);
    tooltip.style.display = 'block';
  }

  function positionTooltip(target) {
    const rect = target.getBoundingClientRect();
    tooltip.style.opacity = '0';
    tooltip.style.display = 'block';
    tooltip.style.maxWidth = '';

    const ttRect = tooltip.getBoundingClientRect();
    const scrollX = window.pageXOffset;
    const scrollY = window.pageYOffset;
    const margin = 20;

    let top = scrollY + rect.top + (rect.height / 2) - (ttRect.height / 2);
    const topMax = scrollY + window.innerHeight - ttRect.height - 10;
    const topMin = scrollY + 10;
    top = Math.min(Math.max(top, topMin), topMax);

    let left = scrollX + rect.right + margin;

    if (left + ttRect.width > scrollX + window.innerWidth - 10) {
      left = scrollX + rect.left - ttRect.width - margin;
      if (left < scrollX + 10) {
        top = scrollY + rect.bottom + 15;
        left = scrollX + rect.left;
        if (top + ttRect.height > scrollY + window.innerHeight - 10) {
          top = scrollY + rect.top - ttRect.height - 15;
        }
      }
    }

    tooltip.style.top = `${Math.round(top)}px`;
    tooltip.style.left = `${Math.round(left)}px`;
    tooltip.style.opacity = '1';
  }

  function clearTexts() {
    inputText.value = '';
    outputText.value = '';
    const highlightedOutput = document.getElementById('highlightedOutput');
    highlightedOutput.innerHTML = '';
    highlightedOutput.style.display = 'none';
    outputText.style.display = 'block';

    const statsContainer = document.getElementById('translationStats');
    if (statsContainer) {
      statsContainer.style.display = 'none';
    }

    updateCharCount();
  }

  function copyTranslation() {
    let textToCopy;
    const highlightedOutput = document.getElementById('highlightedOutput');

    if (highlightedOutput.style.display === 'block') {
      textToCopy = highlightedOutput.innerText;
    } else {
      textToCopy = outputText.value;
    }

    if (!textToCopy.trim()) return;

    navigator.clipboard.writeText(textToCopy).then(() => {
      const copyBtn = document.getElementById('copyButton');
      const btnText = copyBtn.querySelector('.btn-text');
      const originalText = btnText ? btnText.textContent : copyBtn.textContent;
      const copiedText = ui.copied || 'Kopiert!';

      if (btnText) {
        btnText.textContent = copiedText;
      } else {
        copyBtn.textContent = copiedText;
      }
      copyBtn.classList.add('copy-success');

      setTimeout(() => {
        if (btnText) {
          btnText.textContent = originalText;
        } else {
          copyBtn.textContent = originalText;
        }
        copyBtn.classList.remove('copy-success');
      }, 2000);
    }).catch(err => {
      console.error('Copy failed:', err);
    });
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  // Video tutorial click handlers
  document.querySelectorAll('.complex-technique-item[data-term]').forEach(item => {
    item.addEventListener('click', function() {
      const term = this.getAttribute('data-term');
      if (complexDict[term] && complexDict[term].videoId) {
        window.open(`https://youtube.com/watch?v=${complexDict[term].videoId}`, '_blank');
      }
    });
  });

  init();
});
